import classNames from 'classnames';
import { Skeleton } from '@mui/material';
import { IconType } from 'react-icons';
import './TextWithIcon.scss';
import { IconSkeleton } from 'app/agriculture/components/IconSkeleton';

interface TextWithIconSkeletonProps {
    className?: string;
    Icon?: IconType;
    width?: number;
}

export function TextWithIconSkeletonProps({
    className,
    Icon = IconSkeleton,
    width = 120,
}: TextWithIconSkeletonProps) {
    return (
        <div className={classNames(className, 'TextWithIcon')}>
            <Icon className="TextWithIcon__icon" size={20} />
            <h5 className="TextWithIcon__text">
                <Skeleton variant="text" animation="wave" width={width} />
            </h5>
        </div>
    );
}
